(() => {
  if (window.swingn9tVitalsCheckout || window.Shopify?.designMode) return;
  window.swingn9tVitalsCheckout = true;
  const key = 'swingn9t_vitals_checkout_deadline_v1';
  const duration = 10 * 60 * 1000;
  let deadline;
  const style = document.createElement('style');
  style.textContent = `.sn9t-vitals-checkout h2{font-size:26px!important;line-height:1.2!important;margin-bottom:12px!important}.sn9t-checkout-clock{display:block;margin:0 0 14px;padding:10px 14px;border-radius:4px;background:#1af5ea;color:#111;text-align:center;font:700 20px/1.3 Arial,sans-serif;letter-spacing:.3px}.sn9t-checkout-link{display:block;margin:16px 0 0;padding:14px 12px;border-radius:4px;background:#1af5ea;color:#111!important;text-decoration:none!important;text-align:center;font:700 16px/1.3 Arial,sans-serif}.sn9t-checkout-link:focus-visible{outline:3px solid white;outline-offset:3px}@media(max-width:600px){.sn9t-vitals-checkout h2{font-size:24px!important}.sn9t-checkout-clock{font-size:18px}}`;
  document.head.append(style);
  const layout = document.createElement('style');
  layout.textContent = `dialog.Vtl-Popup:has(.sn9t-vitals-checkout) .Vtl-Modal__Content,dialog.Vtl-Popup:has(.sn9t-vitals-checkout) .Vtl-Popup__Container{height:auto!important;max-height:calc(100dvh - 32px)!important}dialog.Vtl-Popup:has(.sn9t-vitals-checkout) .Vtl-Popup__Content{height:auto!important;max-height:none!important;padding:48px 24px 24px!important;overflow:visible!important}.sn9t-vitals-checkout .Vtl-Popup__Description{font-size:15px!important;line-height:1.45!important}`;
  document.head.append(layout);
  const getDeadline = () => {
    if (deadline) return deadline;
    let previous;
    try { previous = JSON.parse(sessionStorage.getItem(key)); } catch {}
    const now = Date.now();
    if (previous && Number.isFinite(previous.started) && Number.isFinite(previous.ends) && now - previous.started < 86400000) {
      deadline = previous.ends;
    } else {
      deadline = now + duration;
      try { sessionStorage.setItem(key, JSON.stringify({started: now, ends: deadline})); } catch {}
    }
    return deadline;
  };
  const updateClocks = () => {
    if (!deadline) return;
    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    document.querySelectorAll('[data-sn9t-checkout-clock]').forEach(clock => {
      clock.hidden = seconds === 0;
      clock.style.display = seconds === 0 ? 'none' : '';
      if (seconds) {
        const value = `Check out in ${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
        if (clock.textContent !== value) clock.textContent = value;
      }
    });
  };
  const enhance = () => {
    document.querySelectorAll('h2').forEach(heading => {
      const text = heading.textContent.trim().toLowerCase();
      const signup = text === 'before you go—save 15%' || text === 'before you go, save 15%';
      const success = text === 'your 15% off is ready';
      if ((!signup && !success) || !heading.getClientRects().length) return;
      let scope = heading.parentElement;
      for (let depth = 0; scope && depth < 6; depth++, scope = scope.parentElement) {
        const email = scope.querySelector('input[type="email"]');
        const copy = Array.from(scope.querySelectorAll('button')).some(button => /copy.*discount|copy.*code/i.test(button.textContent));
        if ((signup && email) || (success && copy)) break;
      }
      if (!scope || scope === document.body || scope === document.documentElement) return;
      scope.classList.add('sn9t-vitals-checkout');
      if (!scope.querySelector('[data-sn9t-checkout-clock]')) {
        const clock = document.createElement('div');
        clock.className = 'sn9t-checkout-clock';
        clock.dataset.sn9tCheckoutClock = 'true';
        clock.setAttribute('role', 'timer');
        clock.setAttribute('aria-label', 'Checkout countdown');
        clock.setAttribute('aria-live', 'off');
        heading.before(clock);
        getDeadline();
        updateClocks();
      }
      if (success && !scope.querySelector('[data-sn9t-checkout-link]')) {
        const link = document.createElement('a');
        link.className = 'sn9t-checkout-link';
        link.dataset.sn9tCheckoutLink = 'true';
        link.href = '/discount/STAY15?redirect=/checkout';
        link.textContent = 'Apply 15% & checkout now';
        scope.append(link);
      }
    });
  };
  let queued = false;
  const observer = new MutationObserver(records => {
    if (queued || !records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  });
  observer.observe(document.body, {childList: true, subtree: true});
  enhance();
  setInterval(updateClocks, 1000);
})();
